module.exports = __webpack_public_path__ + "static/media/38-3.26b5495d.mp3";